import { theme } from "@src/theme";
import styled from "styled-components";

export const PlaylistBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 80px;
  background-color: ${theme.colors.darkGray};
  color: ${theme.colors.white};
  /* Allow content to wrap so the SearchInput doesn't get clipped when tags get long */
  flex-wrap: wrap;
  overflow: visible;
`;

export const PlaylistDetailsBarPlaylistInfo = styled.div`
  display: flex;
  flex-direction: column;
  fontweight: bold;
  margin-right: ${theme.margins.mediumL};
  color: ${theme.colors.gray};
`;

export const PlaylistDetailsBarPlaylistInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  fontweight: bold;
  margin-right: ${theme.margins.mediumL};
  gap: ${theme.margins.small};
  color: ${theme.colors.gray};
`;
export const PlaylistDetailsBarInfoTextRow = styled.span`
  font-size: 0.8rem;
  font-weight: bold;
  color: ${theme.colors.gray};
`;
export const PlaylistDetailsBarInfoValueRow = styled.span`
  font-size: 0.8rem;
  font-weight: bold;
  color: ${theme.colors.yellow};
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PlaylistDetailsBarInfoText = styled.span`
  color: ${theme.colors.yellow};
  font-size: 0.8rem;
  font-weight: bold;
`;

export const PlaylistDetailsBarInfoValue = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: capitalize;
`;

export const PlaylistDetailsBarColContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;
`;

export const PlaylistDetailsInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  gap: ${theme.margins.small};
  min-width: 0;
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
  row-gap: ${theme.margins.xsmall};
`;

export const SearchInputWrapper = styled.div`
  flex: 0 1 auto;
  width: 250px;
  min-width: 200px;
  max-width: 300px;
  margin-left: auto;
`;
